export default "__VITE_ASSET__BmXe8a5n__"